import { render, staticRenderFns } from "./fpaLtoDetail.vue?vue&type=template&id=54226abd&scoped=true"
import script from "./fpaLtoDetail.vue?vue&type=script&lang=js"
export * from "./fpaLtoDetail.vue?vue&type=script&lang=js"
import style0 from "./fpaLtoDetail.vue?vue&type=style&index=0&id=54226abd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54226abd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54226abd')) {
      api.createRecord('54226abd', component.options)
    } else {
      api.reload('54226abd', component.options)
    }
    module.hot.accept("./fpaLtoDetail.vue?vue&type=template&id=54226abd&scoped=true", function () {
      api.rerender('54226abd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/fpaManage/fpaLto/fpaLtoDetail.vue"
export default component.exports